import { useEffect } from 'react';

export function usePreloadImage(url) {
  useEffect(() => {
    if (!url) return;
    const img = new Image();
    img.src = url;
  }, [url]);
}
